/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {pauseTile} from '../api'

export const useMutationPauseTile = createReactQueryMutationHook('pauseTile', pauseTile)
